import React from 'react';
import { accountTypes, isContributory } from '../../flows/shared/utils';
import { getRetirementTypeDisplay } from '../../screens/ProfileScreen/util';

export const INELIGIBLE_CUSIPS = [
  '921937686',
  '92203J100',
  '921909818',
  '92203J308',
  '921937710',
  '92206C888',
  '921908828',
  '922031506',
  '922042734',
  '68381K101',
  '68381K200',
  '68381K309',
  '68381K606',
  '68381K507',
  '68381K408',
  '38142B872',
  '47103E668',
  '001413137',
  '00142C771',
  '02630R401',
  '02630R781'
];

export const disqualifiedByCusip = (externalAccounts = []) =>
  externalAccounts.some(
    ({ cusip }) =>
      INELIGIBLE_CUSIPS.includes(cusip) || cusip === undefined || cusip === ''
  );

/* eslint-disable complexity */
export const getAccountName = (accountType, iraAccountType = '') => {
  switch (accountType) {
    case accountTypes.JOINT:
      return 'Joint';
    case accountTypes.UGMAUTMA:
      return 'UGMA/UTMA';
    case accountTypes.INDIVIDUAL:
      return 'Individual';
    case accountTypes.ROLLOVER:
      return 'Rollover IRA';
    case accountTypes.CONTRIBUTORY:
      return getRetirementTypeDisplay(iraAccountType);
    default:
      return 'Transfer IRA';
  }
};
/* eslint-enable complexity */

export const getAccountNameHeader = (accountType, iraAccountType, customer) =>
  `${' '}Congratulations, ${customer.name.firstName}. Your ${getAccountName(
    accountType,
    iraAccountType
  )}${isContributory(accountType) ? '' : ' account'} has been established.`;

// determine if account is transfer on death (TOD)
// applicable for only Taxable Individual & Joint accounts
// set up with beneficiaries
export const isTODAccount = (accountType, benes) => {
  const isIndividualOrJoint =
    accountType === accountTypes.INDIVIDUAL ||
    accountType === accountTypes.JOINT;
  return (
    isIndividualOrJoint &&
    benes &&
    (benes.individuals?.length > 0 || benes.entities?.length > 0)
  );
};

export const getConfirmationHeading = (appState, isRollover) => {
  const {
    store: {
      accountType,
      app: { customer, iraAccountType },
      rpsDirectRollover,
      loadedData
    }
  } = appState;

  if (loadedData?.is504Timeout)
    return (
      <>
        Your new account set up is taking longer than expected,{' '}
        <span className="blocked_data">{customer?.name?.firstName}</span>, and
        should be available in a few minutes.
      </>
    );

  if (isRollover && rpsDirectRollover)
    return `Nice work, now let's activate your rollover`;

  return getAccountNameHeader(accountType, iraAccountType, customer);
};

export const getConfirmationSubHeading = appState => {
  const {
    store: {
      accountType,
      app: { customer, beneficiaries },
      loadedData
    }
  } = appState;

  if (loadedData?.is504Timeout)
    return (
      <>
        Please check your email sent to{' '}
        <span className="blocked_data">{customer?.primaryEmailAddress}</span>{' '}
        and follow the steps below once received. If you do not receive a
        confirmation email, please call an Investment Specialist at{' '}
        <a rel="noopener noreferrer" href="tel:1-800-332-6161">
          1-800-332-6161
        </a>
        .
      </>
    );

  if (isTODAccount(accountType, beneficiaries))
    return `A confirmation email is on the way. Your account registration will include the designation 'TOD' for Transfer on Death.`;

  return (
    <>
      An email confirming your new account has been sent to{' '}
      <span className="blocked_data">{customer?.primaryEmailAddress}</span>
    </>
  );
};
